import React from 'react';

const ChatLayout = ({ children }) => {
  return (
    <div className="flex h-[calc(100vh-64px)] w-full overflow-hidden bg-white rounded-lg shadow-sm border border-gray-200">
      {children}
    </div>
  );
};

export default ChatLayout;
